"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function BlogIndexRedirect() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/blog/1");
  }, []);

  return <div></div>;
}
